import { Link } from "react-router-dom";
import { Separator } from "@/components/ui/separator";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#111827] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-[#0056D2] rounded-md flex items-center justify-center">
                <span className="text-white font-bold text-sm">GR</span>
              </div>
              <span className="font-heading text-lg font-bold">
                GlitchRealm Foundation
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
              Supporting young developers and student projects. Helping the next
              generation build and launch real projects online.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-sm uppercase tracking-wider text-gray-300 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: "Home", to: "/" },
                { label: "Apply for Support", to: "/apply" },
                { label: "Programs", to: "/#programs" },
                { label: "Contact", to: "/#contact" },
              ].map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-gray-400 hover:text-white text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold text-sm uppercase tracking-wider text-gray-300 mb-4">
              Contact
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="mailto:contact@glitchrealm.com"
                  data-testid="footer-email-link"
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                >
                  contact@glitchrealm.com
                </a>
              </li>
              <li>
                <a
                  href="https://glitchrealm.ca"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-main-site-link"
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                >
                  glitchrealm.ca
                </a>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="my-8 bg-gray-700" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-gray-500">
          <p data-testid="footer-copyright">
            &copy; {new Date().getFullYear()} GlitchRealm Foundation. All rights reserved.
          </p>
          <p>
            A program of{" "}
            <a
              href="https://glitchrealm.ca"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors"
            >
              GlitchRealm
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
